import React from 'react'
import styles from '../../styles/pages/[blogId].module.scss';

const ShareThisPost = ({ socialButtons }) => {
  const strings = {
    share_this_post: 'Share this post',
  }

  return (
    <section className="centerContent shareSection">
      <h5>{strings.share_this_post}</h5>
      <div className={styles.socialButtons}>
        {
          socialButtons ? socialButtons?.map((button: any) => (
            <a href={button.href} target="_blank" key={button.name} rel='noreferrer'>
              <div className={styles.socialButton} style={{ color: button.color, border: `1px solid ${button.color}` }}>
                {button.icon}
              </div>
            </a>
          )) : null
        }
      </div>
    </section>
  )
}

export default ShareThisPost
